export default __webpack_public_path__ + "static/media/alertErrorIcon.d97f9171.svg";